import { compose } from 'redux'

import withErrorBoundary from 'components/shared/withErrorBoundary'
import withRedux from './withRedux'
import withFormResults from 'components/shared/withFormResults'
import withMutation from './withMutation'
import withState from './withState'
import withEventHandlers from './withEventHandlers'

// presentational components
import UI from './UI'

const withNewEmergencyContactForm = options => {
  const { redirect, onSuccess } = options
  const withNewEmergencyContactFormResults = withFormResults({
    mutation: 'createEmergencyContact',
    field: 'emergencyContact',
    successMessage: 'Emergency contact added',
    onSuccess,
    redirect
  })

  return compose(
    withErrorBoundary,
    withRedux,
    withNewEmergencyContactFormResults,
    withMutation,
    withState,
    withEventHandlers
  )
}

// in account manager, redirect to overview
export default withNewEmergencyContactForm({
  redirect: '/'
})(UI)

// for registration
export { withNewEmergencyContactForm }
